import { ITEM_TYPES } from '../betslip';
/**
 * @typedef {import('./interfaces').BetslipItem} BetslipItem
 * @typedef {import('./interfaces').BetslipMatchItem} BetslipMatchItem
 */

export default class PlaceItemModel {
	/**
	 * absi model
	 * @param {BetslipItem} item - betslip item
	 * @param {BetslipMatchItem} match - betslip match item
	 * @param {boolean} banker - banker flag
	 */
	constructor(item, match, banker = false) {
		/**
		 * Special bet value
		 * @type {string}
		 */
		this.SpecialBetValue = item.sbv || '';
		/**
		 * Outcome id
		 * @type {number}
		 */
		this.oid = item.oddTypeOutcomeId || item.outcomeId;
		/**
		 * Item type
		 * @type {number}
		 */
		this.it = item.itemType;
		/**
		 * Item match id
		 * @type {number}
		 */
		this.mid = item.matchId;
		/**
		 * Odd value
		 * @type {string}
		 */
		this.oo = item.odd;
		/**
		 * Flag if item is banker
		 * @type {boolean}
		 */
		this.b = banker;
		/**
		 * Item sport id
		 * @type {number}
		 */
		this.sid = match.sportId;
		/**
		 * Item tournament id
		 * @type {number}
		 */
		this.tid = match.tournamentId;
		/**
		 * Item category id
		 * @type {number}
		 */
		this.cid = match.categoryId;
		/**
		 * Item player market id
		 * @type {number}
		 */
		this.potid = item.playerOddTypeId || 0;
		/**
		 * Item competitor id
		 * @type {number}
		 */
		this.cmid = item.itemType === ITEM_TYPES.OUTRIGHT ? item.playerOddTypeId : item.matchId;
		/**
		 * Item odd type outcome id
		 * mainly used for outrights and horse races
		 * @type {number}
		 */
		this.otoid = item.oddTypeOutcomeId || 0;

		/**
		 * Item odd type group outcome id
		 * only used for horse races group type forecast/tricast
		 * @type {number}
		 */
		this.cogid = item.competitorGroupId || null;
		/**
		 * Item market id
		 * @type {number}
		 */
		this.otid = item.marketId;
		/**
		 * Item identifier if any
		 * mainly used for live betting
		 * @type {string}
		 */
		this.id = item.identifier || 0;
		/**
		 * Item specifier if any
		 * mainly used for live betting
		 * @type {string}
		 */
		this.s = item.specifier || undefined;
	}
}
